import React, { useCallback, useEffect, useState } from 'react';
import { getUnixTime } from 'date-fns';
import PropTypes from 'prop-types';

// Components
import Search from '../Search';
import SearchResults from '../Search/SearchResults';
import EventSessionCard from '@molecules/EventSessionCard';
import EventSessionListItem from '@molecules/EventSessionListItem';

// Helpers
import { SAVED_SESSIONS_QUERY } from '@general/graphql/session.graph';
import { mapSearchSessionToProps } from '@general/transforms/session.transform';

const SearchSessionsForDay = ({
    event,
    activeDay,
    showFavoriteIcon = true,
    showSearchBox = false,
    showSearchOptions = false,
    hitsPerPage = 1000,
}) => {
    const [filters, setFilters] = useState('content_type:session');

    useEffect(() => {
        const filterArray = ['content_type:session', `event.event_code:${event.event_code}`];

        const day = activeDay.getDate();
        const month = activeDay.getMonth();
        const year = activeDay.getFullYear();
        const dayStartUnix = getUnixTime(new Date(year, month, day));
        const dayEndUnix = getUnixTime(new Date(year, month, day + 1));

        filterArray.push(`session_start_time >= ${dayStartUnix}`);
        filterArray.push(`session_start_time < ${dayEndUnix}`);

        setFilters(filterArray.join(' AND '));
    }, [event, activeDay]);

    const mapData = useCallback(
        data => {
            return {
                ...mapSearchSessionToProps(data),
                showFavoriteIcon,
            };
        },
        [showFavoriteIcon]
    );

    return (
        <Search
            index="everything_session_start_time_asc_virtual"
            defaultViewType="list"
            displaySearchBox={showSearchBox}
            displaySearchOptions={showSearchOptions}
            hitsPerPage={hitsPerPage}
            filters={filters}
        >
            <SearchResults
                cardComponent={EventSessionCard}
                listItemComponent={EventSessionListItem}
                index="everything_session_start_time_asc_virtual"
                query={SAVED_SESSIONS_QUERY}
                resultsPerRow={1}
                transformFunc={mapData}
                typePlural="sessions"
                NoResultsText={() => <>Coming Soon.</>}
            />
        </Search>
    );
};

SearchSessionsForDay.propTypes = {
    event: PropTypes.shape({
        event_code: PropTypes.string.isRequired,
    }),
    activeDay: PropTypes.instanceOf(Date),
    showFavoriteIcon: PropTypes.bool,
    showSearchBox: PropTypes.bool,
    showSearchOptions: PropTypes.bool,
    hitsPerPage: PropTypes.number,
};

export default SearchSessionsForDay;
